import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { buildLinkYearsClassroom } from 'src/app/data/factory/link-years-classroom.factory';
import { LinkYearsClassrooms } from 'src/app/data/models/dto/link-years-classrooms';
import { LinkYearClassroomsComponent } from '../link-year-classrooms/link-year-classrooms.component';

@Component({
  selector: 'app-button-link-year-classrooms',
  templateUrl: './button-link-year-classrooms.component.html',
  styleUrls: ['./button-link-year-classrooms.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ButtonLinkYearClassroomsComponent implements OnInit {
  @Input() classroomYear: string | undefined;
  @Input() idsClassrooms: string[] | undefined;
  @Input() text: string | undefined;

  @Output() outputData = new EventEmitter<LinkYearsClassrooms>();

  constructor(public readonly dialog: MatDialog) {}

  ngOnInit(): void {}

  openDialog() {
    const dialogRef = this.dialog.open(LinkYearClassroomsComponent, {
      data: buildLinkYearsClassroom(
        this.classroomYear!,
        this.text!,
        this.idsClassrooms!
      ),
    });

    dialogRef.afterClosed().subscribe((result: LinkYearsClassrooms) => {
      if (result) {
        this.outputData.emit(result);
      }
    });
  }
}
